import { render, staticRenderFns } from "./ChangeProfilePassword.vue?vue&type=template&id=2eb6cd7f&"
import script from "./ChangeProfilePassword.vue?vue&type=script&lang=js&"
export * from "./ChangeProfilePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports